import React, { useState } from "react";

import { trackAmplitudeEvent } from "../../amplitude";
import { STORIES_EVENTS } from "./storiesEvents";
import { requestJson } from "./storiesHelpers";

export default function StoryRating({ feedbackUrl, mode, storyId }) {
  const [hasRated, setHasRated] = useState(false);

  const rate = async (upVote) => {
    trackAmplitudeEvent(STORIES_EVENTS.STORY_RATED, { mode, story_id: storyId, up_vote: upVote });
    setHasRated(true);
    try {
      await requestJson({ data: { up_vote: upVote }, method: "post", url: feedbackUrl });
    } catch {
      setHasRated(false);
    }
  };

  if (hasRated) {
    return <p className="story-rating text-muted">Thanks for letting us know!</p>;
  }

  return (
    <div className="story-rating">
      <span>Did you enjoy this story?</span>
      <button aria-label="I enjoyed this story" className="btn btn-default" type="button" onClick={() => rate(true)}>
        <span className="fa fa-thumbs-up" />
      </button>
      <button aria-label="I did not enjoy this story" className="btn btn-default" type="button" onClick={() => rate(false)}>
        <span className="fa fa-thumbs-down" />
      </button>
    </div>
  );
}
